/* import __COLOCATED_TEMPLATE__ from './ip-allowlist-settings.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { run } from '@ember/runloop';
import type IntlService from 'ember-intl/services/intl';
import type SecurityAppSettings from 'embercom/models/security-app-settings';
import type { ComponentLike } from '@glint/template';

interface IpAllowlistSettingsArgs {
  settings: SecurityAppSettings;
}

interface Signature {
  Args: IpAllowlistSettingsArgs;
}

export default class IpAllowlistSettings extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare intercomEventService: $TSFixMe;
  @service declare appService: AppService;

  @tracked settings = this.args.settings;

  get descriptionText(): string {
    return this.intl.t('apps.app.settings.security.ip-allowlist-new-description');
  }

  @action
  toggleAllowlistEnabled(): void {
    this.settings.ipAllowlistEnabled = !this.settings.ipAllowlistEnabled;
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'ip_allowlist_switch',
      ip_allowlist_enabled: this.settings.ipAllowlistEnabled,
    });
  }

  @action
  updateIpAllowlist(): void {
    // We need to run this in a runloop because the the on modifier does not schedule the event listener onto the run loop
    // https://github.com/emberjs/ember.js/issues/19222#issuecomment-1049773929
    run(() => {
      this.settings.updateIpAllowlist();
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Settings::Security::IpAllowlistSettings': ComponentLike<{ Args: { settings: any } }>;
    'settings/security/ip-allowlist-settings': ComponentLike<{ Args: { settings: any } }>;
  }
}
